import { Theme } from '@mint-lib/styled';

import Typography from '../Typography/Typography.jsx';
import { Step } from './Stepper.jsx';

export const controlColorDescription = (status: string, theme: Theme) =>
  ({
    active: theme.palette.text.secondary,
    completed: theme.palette.text.secondary,
    uncompleted: theme.palette.text.secondary,
    error: theme.palette.text.error,
  })[status] as string;

export const renderDescription = (status: string, step: Step) =>
  step.description ? (
    <Typography
      variant="caption02"
      sx={{
        color: (theme) =>
          step?.disabled
            ? theme.palette.text.disabled
            : controlColorDescription(status, theme),
      }}
    >
      {step.description}
    </Typography>
  ) : null;
